import React, { useEffect } from 'react';
//import $ from "jquery";

import { Link } from 'react-router-dom';

import MainImgSmall from '../assets/img/Icons/Icons/smallimgicon.png'
import MainImg from '../assets/img/signin2.png'


const Signin2 = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 text-center">
                    <img src={MainImgSmall} alt="" srcset="" className="MainImgSmall-s1 mt-3" height={"38px"}/>
                 
                        <h2 className="font-weight-bold signin1-h3 mt-3 ">Sign In</h2>
                        <img src={MainImg} alt="" srcset="" className="MainImg-s1 " />
                    </div>

                </div>
            </div>
            <div className=" p-4 mt-3" style={{ borderRadius: "20px 20px 0 0", boxShadow: "0 -0.3rem 1rem rgba(0,0,0,.15)" }}>
                <div className="row ">
                    <div className="col-sm-12">
                        <div className="">
                            <form className="signin2-form">
                                <div className="form-group">
                                    <label for="exampleInputEmail1">Email Id </label>
                                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email" />
                                </div>
                                <div className="form-group">
                                    <label for="exampleInputEmail1">Password</label>
                                    <input type="password" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Password" />
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 col">
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                            <label className="form-check-label" for="exampleCheck1">Check me out</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col">
                                        <p className="float-right"><a href="" className="si2-green  text-decoration-none">Forget Password</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-sm-12 bottom-btm-font mt-2">
                    <Link to="/Coupens" type="button" className="btn btn-success w-100 mt-3 py-2">Sign In</Link>
                    </div>
                    <div className="col-sm-12 text-center mt-3 ">
                        <p>New User ? <span><Link to="/Register1" className="text-decoration-none text-red fw500">Register Here</Link></span></p>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Signin2;